import { writable } from "svelte/store";

export type ConversationBubbleData = {
    groupId: number;
    userIds: number[];
    x: number;
    y: number;
    locked: boolean;
};

export const conversationBubblesStore = writable<Map<number, ConversationBubbleData>>(new Map());

export function addOrUpdateConversationBubble(data: ConversationBubbleData): void {
    conversationBubblesStore.update((bubbles) => {
        const newMap = new Map(bubbles);
        newMap.set(data.groupId, data);
        return newMap;
    });
}

export function removeConversationBubble(groupId: number): void {
    conversationBubblesStore.update((bubbles) => {
        const newMap = new Map(bubbles);
        newMap.delete(groupId);
        return newMap;
    });
}

export function updateConversationBubbleUsers(groupId: number, userIds: number[]): void {
    conversationBubblesStore.update((bubbles) => {
        const bubble = bubbles.get(groupId);
        if (!bubble) return bubbles;
        const newMap = new Map(bubbles);
        newMap.set(groupId, { ...bubble, userIds });
        return newMap;
    });
}
